<script lang="ts">
  import type { IUPicture, IULink } from "../../../core/types";
  import DocumentItem from "../../blocks/DocumentItem.svelte";

  interface IDocumentItem {
    id: number;
    name: string;
    umbracoFile: IUPicture;
    umbracoExtension: string;
    url: string;
  }

  interface IDocumentsLibraryPanel {
    link: IULink;
    listOrder: string;
    title: string;
    mediaLibrary: IDocumentItem[];
  }

  export let data: IDocumentsLibraryPanel;
</script>

<section class="document-library g-centered">
  <div class="title">
    {data.title}
  </div>

  <div class="items">
    {#each data.mediaLibrary as item}
      <DocumentItem
        url={item.url}
        name={`${item.name}.${item.umbracoExtension}`}
      />
    {/each}
  </div>
</section>

<style lang="scss">
  .document-library {
    margin-bottom: 42px;
  }

  .title {
    @include h2;
    margin-bottom: 20px;
  }
</style>
